/**
 * Rutas de Administración — acceso vía routeAccessMatrix.js
 */
import { Route } from 'react-router-dom'
import ProtectedRoute from '../components/ProtectedRoute.jsx'
import PermissionRoute from '../components/PermissionRoute.jsx'
import Monitor from '../pages/seguridad/monitoring/Monitor.jsx'
import Logs from '../pages/seguridad/logs/Logs.jsx'
import Usuarios from '../pages/administracion/users/Usuarios.jsx'
import RolesPermisos from '../pages/administracion/roles-permisos/RolesPermisos.jsx'

const withAcl = (Page) => (
  <ProtectedRoute>
    <PermissionRoute>
      <Page />
    </PermissionRoute>
  </ProtectedRoute>
)

export const adminRoutes = [
  <Route key="seguridad" path="/seguridad" element={withAcl(Monitor)} />,
  <Route key="logs" path="/logs" element={withAcl(Logs)} />,
  <Route key="usuarios" path="/usuarios" element={withAcl(Usuarios)} />,
  <Route key="roles-permisos" path="/roles-permisos" element={withAcl(RolesPermisos)} />,
]
